import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import ProcessDocumentPromo from '../../../../assets/images/promo-process-document.png'

import './ProcessDocumentUpsell.scss'

export const ProcessDocumentUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={<img src={ProcessDocumentPromo} alt='Document intelligence promo' className='zocks-border-0.5 process-document-upsell-promo' />}
      heading='Turn documents into insights instantly'
      description='Upload any document and AI extracts financial changes, life events, and key updates, then syncs to your CRM and financial systems. Zero manual data entry.'
    />
  )
}

export const ProcessDocumentUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem
        title='AI-powered extraction'
        description='Automatically identifies account balances, transactions, portfolio changes from documents.'
      />
      <UpsellFeatureItem title='Sync-ready data' description='Extracted insights are ready to sync directly to your CRM and financial planning systems.' />
      <UpsellFeatureItem
        title='Custom templates'
        description='Configure what data to extract in what format for different document types to match your workflow.'
        className='mb-3'
      />
    </>
  )
}
